import { createFileRoute } from "@tanstack/react-router";

import TeamMembers from "@/containers/TeamMembers";

export const Route = createFileRoute("/_app/(account)/users")({
  component: () => <TeamMembers />,
});
